import { useState } from 'react'

import { Portal } from 'components/portal'
import { Button } from '../styled'
import {
  Backdrop,
  CloseButton,
  Inner,
  Modal,
  Outer,
  Video,
  VideoWrapper,
} from './styled'

export const VideoSection = () => {
  const [isOpen, setOpen] = useState(false)

  return (
    <VideoWrapper>
      <Video
        src="https://rfe.pangea-cms.com/videoroot/pangeavideo/2024/08/0/01/01000000-c0a8-0242-3223-08dcc5c21417_1080p.mp4"
        autoPlay
        playsInline
        loop
        muted
      />

      <Button as="button" onClick={() => setOpen(true)}>
        Смотреть трейлер
      </Button>

      {isOpen && (
        <Portal>
          <Modal>
            <Backdrop onClick={() => setOpen(false)} />
            <Outer>
              <Inner>
                <iframe
                  src="https://www.votvot.tv/embed/player/0/33118652.html?type=video"
                  scrolling="no"
                  allowFullScreen
                />
              </Inner>
            </Outer>
            <CloseButton onClick={() => setOpen(false)} />
          </Modal>
        </Portal>
      )}
    </VideoWrapper>
  )
}
